module.exports = __webpack_public_path__ + "img/Anlagefuehrerin-MS-116.b82c9c55.jpg";